export const getType = (type: string): string => type === 'promotions' && window.settings.config.promo_news_active <= 0
    ? 'promotions_old'
    : type;
